import {navigate} from 'gatsby';
import {getLanguageUrl} from './language-url';

const langNavigate = (langInfo, path, options) => {
    return navigate(getLanguageUrl(langInfo, path), options);
};

export default langNavigate;
